// import { lazy } from "react";
import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import patientCareRouteList from "./routeList";
import PrivateRoute from "../Authentication/component/PrivateRoute";
import { base } from "../constants";
import EMR from "../EMR";
import NursingVitals from "./Nursing/vitals";
import VitalsLandingPage from "./Nursing/vitals/vitalsLandingPage";
import TriageLandingPage from "./Nursing/triage/TriageLandingPage";
import NursingTriage from "./Nursing/triage";
import moduleRoutes from "../routes/moduleRouteList";
import Loader from "../utilis/component/SkeletonLoading/Loader";
// import PatientBooking from "./PatientBooking";
// import EmrLandingPage from "../EMR/EmrLanding";
// import PatientEncounter from "../iframeFiles/patientEncounter";
// import BillingComponent from "./Billing";
// import Wallet from "./Wallet/Wallet";
// import RegistrationForm from "./Patientregistration/components/Registrationform";
// import Encounter from "./patientEncounter";
// import ReceptionPatient from "./Reception/components/ReceptionPatient";
// import NursingProcedure from "./Nursing/nursingProcedure";
// const EmrDetailsPage = lazy(()=>import("./allPages/EmrDetails"));
// const PatientBooking = lazy(() => import("./allPages/PatientBookingNew"));
const Cashier = lazy(() => import("./Cashier/index"));
const CashierDetailsv1 = lazy(
  () => import("./Cashier/v1/components/CashierDetailsComponent/CashierPage")
);
const CashierDetailsv2 = lazy(
  () => import("./Cashier/v2/components/CashierDetailsComponent/CashierPage")
);
const BillingDetailsPage = lazy(
  () => import("./Billing/component/BillingDetailsPage")
);

const RegistrationGrantsRouter = lazy(
  () => import("./Patientregistration/PatientRegistrationGrants")
);
const PatientBookingByGrants = lazy(() => import("./PatientBooking/grantsForCalender"));
const BillingComponent = lazy(() => import("./Billing"));
const Encounter = lazy(() => import("./patientEncounter"));
// const ReceptionPatient = lazy(
//   () => import("./Reception/components/ReceptionPatient")
// );
const NursingProcedure = lazy(() => import("./Nursing/nursingProcedure"));
const EmrLandingPage = lazy(() => import("../EMR/EmrLanding/grantsForEmrLanding"));

const LedgerDetailsPage = lazy(() => import("./Cashier/v2/components/ledgerDetails/ledgerDetails"));
const PatientHistoryListing = lazy(() => import("./PatientHistory"));
const PatientDetailsHistory = lazy(() => import("./PatientHistory/PatientDetailsHistory"));

const patientCareRoutes: RouteObject[] = [
  {
    path: patientCareRouteList.patientDetailsHistory,
    element: (
      <PrivateRoute>
        <Loader>
          <PatientHistoryListing />
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path: `${patientCareRouteList.patientDetailsHistory}/:id/:patientId`,
    element: (
      <PrivateRoute>
        <Loader>
          <PatientDetailsHistory />
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path: patientCareRouteList.patientBooking,
    element: (
      <PrivateRoute>
        <Loader>
          <PatientBookingByGrants />
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path: patientCareRouteList.patientRegistration,
    element: (
      <PrivateRoute>
        <div className="p-2">
          <Loader>
            <RegistrationGrantsRouter />
          </Loader>
        </div>
      </PrivateRoute>
    ),
  },
  {
    path: `${patientCareRouteList.patientRegistration}/:patientid`,
    element: (
      <PrivateRoute>
        <div className="p-2">
          <Loader>
            <RegistrationGrantsRouter />
          </Loader>
        </div>
      </PrivateRoute>
    ),
  },
  {
    path: `${patientCareRouteList.patientRegistration}/:patientid`,
    element: (
      <PrivateRoute>
        <div className="p-2">
          <Loader>
            <RegistrationGrantsRouter />
          </Loader>
        </div>
      </PrivateRoute>
    ),
  },
  {
    path: patientCareRouteList.patientEnounter,
    element: (
      <PrivateRoute>
        <Loader>
          <Encounter />
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path: `${patientCareRouteList.patientEnounter}/:emrno`,
    element: (
      <PrivateRoute>
        <Loader>
          <Encounter />
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path: `${patientCareRouteList.patientEnounter}/:id/:idType`,
    element: (
      <PrivateRoute>
        <Loader>
          <Encounter />
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path: `${patientCareRouteList.emr}/:encounterId/:patientId`,
    element: (
      <PrivateRoute>
        <Loader>
          <EMR />
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path: `${patientCareRouteList.emrList}`,
    element: (
      <PrivateRoute>
        {/* <EmrDetailsPage /> */}
        <Loader>
          <EmrLandingPage
            path={`${base}${moduleRoutes.mainRoute}/patient-care/emr/`}
          />
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path: `${patientCareRouteList.nursingVitals}`,
    element: (
      <PrivateRoute>
        <VitalsLandingPage />
      </PrivateRoute>
    ),
  },
  {
    path: `${patientCareRouteList.nursingVitals}/:encounterId/:patientId`,
    element: (
      <PrivateRoute>
        <NursingVitals />
      </PrivateRoute>
    ),
  },
  {
    path: patientCareRouteList.nursingTriage,
    element: (
      <PrivateRoute>
        <TriageLandingPage />
      </PrivateRoute>
    ),
  },
  {
    path: `${patientCareRouteList.nursingTriage}/:encounterId`,
    element: (
      <PrivateRoute>
        <NursingTriage />
      </PrivateRoute>
    ),
  },
  {
    path: patientCareRouteList.nursingProcedure,
    element: (
      <PrivateRoute>
        <Loader>
          <NursingProcedure />
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path: patientCareRouteList.billing,
    element: (
      <PrivateRoute>
        <Loader>
          <BillingComponent />
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path: `${patientCareRouteList.billingDetails}/:encounterId`,
    element: (
      <PrivateRoute>
        <Loader>
          <BillingDetailsPage />
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path: patientCareRouteList.payment,
    element: (
      <PrivateRoute>
        <Loader>
          <Cashier />
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path: `${patientCareRouteList.paymentv1}/:billingId/:encounterId/:id`,
    element: (
      <PrivateRoute>
        <Loader>
          <CashierDetailsv1 />
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path: `${patientCareRouteList.paymentv2}/:encounterId/:id`,
    element: (
      <PrivateRoute>
        <Loader>
          <CashierDetailsv2 />
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path: `${patientCareRouteList.patientLedgerDetails}`,
    element: (
      <PrivateRoute>
        <Loader>
          <LedgerDetailsPage />
        </Loader>
      </PrivateRoute>
    ),
  },
];

export default patientCareRoutes;
